import axios from '@/utils/request';
const prefix = process.env.VUE_APP_API_PREFIX_1;
const baseUrl = `${prefix}/product`;

// 产品类别
const ProductType = data => {
  return axios.post(`${baseUrl}/GetProduceGroupList`, data);
};

// 新增产品类别
const AddProductType = data => {
  return axios.post(`${baseUrl}/AddProduceGroup`, data);
};

// 编辑产品类别
const EditProductType = data => {
  return axios.put(`${baseUrl}/UpdateProduceGroup`, data);
};

// 删除产品类别
const DeleteProductType = data => {
  return axios.put(`${baseUrl}/DelProduceGroup`, data);
};

// 产品
const Product = data => {
  return axios.post(`${baseUrl}/GetProduceList`, data);
};

// 产品信息
const ProductInfo = data => {
  return axios.post(`${baseUrl}/GetProduceInfo`, data);
};

// 新增产品
const AddProduct = data => {
  return axios.post(`${baseUrl}/AddProduce`, data);
};

// 编辑产品
const EditProduct = data => {
  return axios.put(`${baseUrl}/UpdateProduce`, data);
};

// 删除产品
const DeleteProduct = data => {
  return axios.put(`${baseUrl}/DelProduce`, data);
};

// 同步信息产品
const SyncInfoProduct = data => {
  return axios.put(`${baseUrl}/SyncProduct`, data);
};

// 控制器
const Controler = data => {
  return axios.post(`${baseUrl}/GetProduce2PlcList`, data);
};

// plc厂家型号协议
const PlcBrandModelProtocol = data => {
  return axios.post(`${baseUrl}/GetPlcList`, data);
};

// 新增控制器
const AddControler = data => {
  return axios.post(`${baseUrl}/AddProduce2Plc`, data);
};

// 编辑控制器
const EditControler = data => {
  return axios.put(`${baseUrl}/UpdateProduce2Plc`, data);
};

// 删除控制器
const DeleteControler = data => {
  return axios.put(`${baseUrl}/DelProduce2Plc`, data);
};

// 事件
const Event = data => {
  return axios.post(`${baseUrl}/GetEventList`, data);
};

// 新增事件
const AddEvent = data => {
  return axios.post(`${baseUrl}/AddEvent`, data);
};

// 编辑事件
const EditEvent = data => {
  return axios.put(`${baseUrl}/UpdateEvent`, data);
};

// 删除事件
const DeleteEvent = data => {
  return axios.put(`${baseUrl}/DelEvent`, data);
};

// 事件选择变量
const SelKeyEvent = data => {
  return axios.post(`${baseUrl}/GetVariableListByEventId`, data);
};

// 导入事件
const ImportEvent = data => {
  return axios.post(`${baseUrl}/BatchAddEvent`, data);
};

// 视频
const Video = data => {
  return axios.post(`${baseUrl}/GetVideoInfoList`, data);
};

// 新增视频
const AddVideo = data => {
  return axios.post(`${baseUrl}/AddVideoInfo`, data);
};

// 编辑视频
const EditVideo = data => {
  return axios.put(`${baseUrl}/UpdateVideoInfo`, data);
};

// 删除视频
const DeleteVideo = data => {
  return axios.put(`${baseUrl}/DelVideoInfo`, data);
};

// 变量
const Key = data => {
  return axios.post(`${baseUrl}/GetVariableList`, data);
};

// 变量名称标识
const KeyNameFlag = data => {
  return axios.post(`${baseUrl}/GetVariableListByCtrlKey`, data);
};

// 新增变量
const AddKey = data => {
  return axios.post(`${baseUrl}/AddVariable`, data);
};

// 编辑变量
const EditKey = data => {
  return axios.put(`${baseUrl}/UpdateVariable`, data);
};

// 删除变量
const DeleteKey = data => {
  return axios.put(`${baseUrl}/DelVariable`, data);
};

// 导入变量
const ImportKey = data => {
  return axios.post(`${baseUrl}/ImportVariable`, data);
};

// 变量列表带置顶
const KeyHasTop = data => {
  return axios.post(`${baseUrl}/GetVariableListNew`, data);
};

// 置顶变量
const IsTopKey = data => {
  return axios.post(`${baseUrl}/CollectVariable`, data);
};

// 报表
const Report = data => {
  return axios.post(`${baseUrl}/GetEventReportList`, data);
};

// 新增报表
const AddReport = data => {
  return axios.post(`${baseUrl}/AddEventReport`, data);
};

// 编辑报表
const EditReport = data => {
  return axios.put(`${baseUrl}/UpdateEventReport`, data);
};

// 删除报表
const DeleteReport = data => {
  return axios.put(`${baseUrl}/DelEventReport`, data);
};

// 文档
const File = data => {
  return axios.post(`${baseUrl}/GetDocsList`, data);
};

// 新增文档
const AddFile = data => {
  return axios.post(`${baseUrl}/AddDocs`, data);
};

// 编辑文档
const EditFile = data => {
  return axios.put(`${baseUrl}/UpdateDocs`, data);
};

// 删除文档
const DeleteFile = data => {
  return axios.put(`${baseUrl}/DelDocs`, data);
};

// 变量是否有历史数据
const CheckVariableHistory = data => {
  return axios.post(`${baseUrl}/CheckVariableHistory`, data);
};

export {
  ProductType,
  AddProductType,
  EditProductType,
  DeleteProductType,
  Product,
  ProductInfo,
  AddProduct,
  EditProduct,
  DeleteProduct,
  SyncInfoProduct,
  Controler,
  PlcBrandModelProtocol,
  AddControler,
  EditControler,
  DeleteControler,
  Event,
  AddEvent,
  EditEvent,
  DeleteEvent,
  SelKeyEvent,
  ImportEvent,
  Video,
  AddVideo,
  EditVideo,
  DeleteVideo,
  Key,
  KeyNameFlag,
  AddKey,
  EditKey,
  DeleteKey,
  ImportKey,
  KeyHasTop,
  IsTopKey,
  Report,
  AddReport,
  EditReport,
  DeleteReport,
  File,
  AddFile,
  EditFile,
  DeleteFile,
  CheckVariableHistory,
};
